export const getModelViewer3dString = (articleCode, modelViewerApiData) => {
  if (!Array.isArray(modelViewerApiData) || modelViewerApiData.length === 0) return null;

  const result = modelViewerApiData.find((item) => item.artNr === articleCode);

  return result
    ? `${result.prefix}/${result.obj}, ${result.prefix}/${result.objMtls.join(`,${result.prefix}/`)}`
    : null;
};
